import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { MyContext } from "../hooks/MyContextProvider";
import Loader from "../Component/Loader";
import Header from "./Header";
import Footer from "./Footer";

import "../assets/css/theme.css";
import "../assets/css/main.css";
const NonAuthLayout = (props) => {
  const { token, loading, isDark } = useContext(MyContext);
  const location = useLocation();

  // List of routes that should not show header and footer
  const authPages = ["/login", "/register", "/forgot-password"];
  const isAuthPage = authPages.includes(location.pathname);

  if (loading) {
    return <Loader />;
  }

  if (isAuthPage) {
    return <Outlet />;
  }

  return (
    <div className="gradient">
      <Header />
      <div className={`${isDark ? "" : "mt-[2px]"}`}>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default NonAuthLayout;
